"use strict";

import scrollToElement from './services/Viewport/scrollToElement';

const subBtn = document.getElementById('subscribe');

subBtn?.addEventListener('click', function () {
	const el = document.getElementById('newsletter-form');

	scrollToElement(el);
});

const header = document.querySelector('.Header');
const links = document.querySelectorAll(".sidebar-link");

for (const link of links) {
	link.addEventListener("click", clickHandler);
}

const changelogScroll = (href) => {
	// let offsetTop = document.querySelector(href)?.offsetTop;
	//
	// offsetTop += header.getBoundingClientRect().height;
	//
	// scroll({
	// 	top: offsetTop,
	// 	behavior: "smooth"
	// });

	const elID = href.replace('#', 'app-');
	const el = document.getElementById(elID);

	scrollToElement(el);

	setTimeout(() => {
		window.location.hash = href;
	}, 300)
};

const openCollapse = (hash) => {
	const accordionItem = document.getElementById(hash.replace('#', 'app-'));
	accordionItem?.classList.add('is-active');

	const accordionContent = accordionItem?.querySelector('.collapse-accordion__content');
	accordionContent.style.height = `${ accordionContent?.scrollHeight }px`;
};

const selectSideMenu = (hash) => {
	const el = document.querySelector('a[href="' + hash + '"]');

	const ul = el.parentElement.parentElement;
	ul.querySelectorAll('li').forEach((liEl) => {
		liEl.classList.remove('active');
	});

	el.parentElement.classList.add('active');
};

function clickHandler(e) {
	e.preventDefault();

	const href = this.getAttribute("href");
	const li = this.closest('li');
	const ul = li.closest('ul');

	ul.querySelectorAll('li').forEach((liEl) => {
		liEl.classList.remove('active');
	});

	li.classList.add('active');

	openCollapse(href);
	changelogScroll(href);
}

const myHash = window.location.hash;

if (myHash) {
	setTimeout(function() {
		window.scrollTo(0, 0);
	}, 1);

	setTimeout(() => {
		openCollapse(myHash);
		selectSideMenu(myHash);
	}, 100);

	changelogScroll(myHash);
} else {
	// Open first
	const changelogAccordion = document.getElementById('CollapseAccordion');
	const first = changelogAccordion.querySelector('.collapse-accordion__item:first-child');
	const firstItemID = first.getAttribute('id');

	openCollapse(firstItemID);
}
